<template>
  <div class="box8">
    <pageTitle title="学员活动" text="项目将定期举办各类线上线下学员活动，以满足在读学员行业信息交流、资源共享或人脉圈层搭建拓展的需求。" />
    <div class="subject-box">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in listSwiper"
          :key="index"
        >
          <div class="box">
            <img :src="item.img" alt="" />
          </div>
        </swiper-slide>
      </swiper>
      
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 16,
        slidesPerView: "auto",
        autoplay: false,
        centeredSlides: true,
        
      },
      listSwiper: [
        {
          img: require("../../../assets/coursePage/mba/box8/img01.png"),
        },
        {
          img: require("../../../assets/coursePage/mba/box8/img02.png"),
        },
        {
          img: require("../../../assets/coursePage/mba/box8/img03.png"),
        }
      ],
    };
  },

  methods: {},
};
</script>

<style  lang="less" scoped>
.box8 {
  padding: 80px 0 48px;
  background: #fff;
  width: 100%;
  .subject-box {
   
    position: relative;
    margin: 48px auto 0;
    overflow: hidden;
    .swiper-container{
      margin-bottom: 32px;
    }
    .swiper-slide {
      border-radius: 20px;
      width: 568px;
    }

    .swiper-pagination-box7 {
      display: flex;
      align-items: center;
      position: absolute;
      left: 50%;
      bottom: 0px;
      transform: translate(-50%, 0px);
      height: 6px;
    
    }

    /deep/ .swiper-pagination-bullet {
      width: 12px;
      height: 6px;
      opacity: 1;
      background: rgba(229,90,46,0.16);
      border-radius: 3px;
      margin-right: 8px;
    }
    /deep/ .swiper-pagination-bullet:last-child {
      margin-right: 0px;
    }

    /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
      width: 24px;
      height: 6px;
      background: #E55A2E;
      border-radius: 3px;
    }

    .swiper-slide {
      width: 568px;
      display: flex;
      justify-content: center;

      box-sizing: border-box;
      .box {
        width: 100%;
        // height: 512px;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
